
import { ReducerRegistry } from '../base/redux';
import { checkIfReactNative } from '../base/util/checkOS';

import {
    CURRENT_TILE_VIEW_PAGE,
    HIDE_LOCAL_PARTICIPANT_IN_STAGE_VIEW,
    SET_FILMSTRIP_ENABLED,
    SET_FILMSTRIP_VISIBLE,
    SET_HIDE_HEADER_FOOTER,
    SET_HORIZONTAL_VIEW_DIMENSIONS,
    SET_TILE_VIEW_DIMENSIONS,
    SET_VISIBLE_PARTICIPANTS_START_INDEX,
    SET_VISIBLE_REMOTE_PARTICIPANTS,
    TILE_VIEW_TILE_LIMIT
} from './actionTypes';

const DEFAULT_STATE = {
    /**
   * The indicator which determines whether the {@link Filmstrip} is enabled.
   *
   * @public
   * @type {boolean}
   */
    enabled: true,

    /**
   * The horizontal view dimensions.
   *
   * @public
   * @type {Object}
   */
    horizontalViewDimensions: {},

    /**
   * The ordered IDs of the remote participants displayed in the filmstrip.
   *
   * @public
   * @type {Array<string>}
   */
    remoteParticipants: [],

    /**
   * The tile view dimensions.
   *
   * @public
   * @type {Object}
   */
    tileViewDimensions: {},

    /**
   * The indicator which determines whether the {@link Filmstrip} is visible.
   *
   * @public
   * @type {boolean}
   */
    visible: true,

    currentTileViewPage: 1,

    /**
   * The end index in the remote participants array that is visible in the filmstrip.
   *
   * @public
   * @type {number}
   */
    visibleParticipantsEndIndex: 0,

    /**
   * The start index in the remote participants array that is visible in the filmstrip.
   *
   * @public
   * @type {number}
   */
    visibleParticipantsStartIndex: 0,

    /**
   * The count of visible participants in the current page.
   *
   * @public
   * @type {number}
   */
    visibleParticipantsCount: 0,

    /**
   * The visible remote participants in the filmstrip.
   *
   * @public
   * @type {Set<string>}
   */
    visibleRemoteParticipants: new Set(),

    /** * The tile limit for the tile view.
   * @public
   * @type {number}
   */
    tileViewTileLimit: checkIfReactNative() ? 6 : 5,

    /** * hide the local participant in stageview.
   * @public
   * @type {Boolean}
   */
    hideLocal: false,

    /** * hide header and footer in filmstrip.
   * @public
   * @type {Boolean}
   */
    hideHeaderFooter: false
};

ReducerRegistry.register(
  'features/filmstrip',
  (state = DEFAULT_STATE, action) => {
      switch (action.type) {
      case SET_FILMSTRIP_ENABLED:
          return {
              ...state,
              enabled: action.enabled
          };

      case SET_FILMSTRIP_VISIBLE:
          return {
              ...state,
              visible: action.visible
          };

      case SET_VISIBLE_REMOTE_PARTICIPANTS: {
          const visibleParticipantsCount = action.endIndex - action.startIndex + 1;

          return {
              ...state,
              visibleParticipantsStartIndex: action.startIndex,
              visibleParticipantsEndIndex: action.endIndex,
              visibleParticipantsCount: visibleParticipantsCount > 0 ? visibleParticipantsCount : 0,
              visibleRemoteParticipants: new Set(
            state.remoteParticipants.slice(
              action.startIndex,
              action.endIndex + 1
            )
              )
          };
      }

      case CURRENT_TILE_VIEW_PAGE: {
          return {
              ...state,
              currentTileViewPage: action.page
          };
      }

      case TILE_VIEW_TILE_LIMIT: {
          return {
              ...state,
              tileViewTileLimit: action.tileViewTileLimit
          };
      }

      case HIDE_LOCAL_PARTICIPANT_IN_STAGE_VIEW: {
          return {
              ...state,
              hideLocal: action.islocal
          };
      }

      case SET_HIDE_HEADER_FOOTER: {
          return {
              ...state,
              hideHeaderFooter: action.hideHeaderFooter
          };
      }

      case SET_VISIBLE_PARTICIPANTS_START_INDEX: {
          return {
              ...state,
              visibleParticipantsStartIndex: action.startIndex
          };
      }

      case SET_HORIZONTAL_VIEW_DIMENSIONS:
          return {
              ...state,
              horizontalViewDimensions: action.dimensions
          };
      case SET_TILE_VIEW_DIMENSIONS:
          return {
              ...state,
              tileViewDimensions: action.dimensions
          };
      }

      return state;
  }
);
